import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { PlatformRedirectHandoff } from "@/types/PlatformRedirectHandoff";

class PlatformRedirectService {
  private path: string;

  constructor(path: string) {
    this.path = path;
  }

  /**
   * Asks the backend whether the current user must be handed off to lazo-platform. POST rather
   * than GET because an affirmative answer mints a single-use one-time code — the request must
   * never be cached or prefetched. Authenticated with the regular bearer.
   *
   * @param sourcePath where the user is (`pathname` + `search`), so the hand-off can land on the
   *   same thing instead of the platform's landing page. The backend translates it through a
   *   closed table; it is never used as a destination verbatim.
   */
  handoff(sourcePath?: string): Promise<ApiResponseV2<PlatformRedirectHandoff>> {
    return HttpClientV2.post(`${this.path}/handoff`, { sourcePath });
  }
}

const platformRedirectService = new PlatformRedirectService("/api/platform-redirect");

export default platformRedirectService;
